import Header from "../components/Header";


function Contact(){


return (

<div className="
min-h-screen
bg-slate-950
text-white
pt-32
">


<Header/>


<section className="
max-w-5xl
mx-auto
px-8
grid
md:grid-cols-2
gap-10
">


<div>


<h1 className="
text-4xl
text-cyan-400
mb-8
">

تماس با ما

</h1>


<p className="text-gray-300 mb-5">

برای ارتباط با تیم MEGA GAMES می‌توانید
از طریق راه‌های زیر با ما در تماس باشید.

</p>


<p>
📞 تلفن:
4039 169 0913
</p>
<p>
📞 تلفن:
5693 345 0990
</p>


<p className="mt-3">
✉ ایمیل:
info@mileh.ir
</p>


</div>





<div className="
bg-slate-900
p-8
rounded-3xl
border
border-slate-700
">


<h2 className="
text-2xl
mb-6
">

ارسال پیام

</h2>


<input

placeholder="نام"

className="
w-full
bg-slate-800
p-3
rounded-xl
mb-4
"

/>


<input

placeholder="شماره تماس"

className="
w-full
bg-slate-800
p-3
rounded-xl
mb-4
"

/>


<textarea

placeholder="پیام شما"

rows="5"

className="
w-full
bg-slate-800
p-3
rounded-xl
"

/>


<button

className="
mt-5
bg-orange-500
px-8
py-3
rounded-xl
"

>

ارسال پیام

</button>


</div>


</section>


</div>


)

}


export default Contact;
